



























































































import { Component, Vue } from 'vue-property-decorator';
import ProjectEditComponent from '@/components/project-edit.vue';
import ProjectAttachmentsComponet from '@/components/project-attachments.vue';
import ProjectLogComponet from '@/components/project-log.vue';
import ProjectRequestsComponet from '@/components/project-requests.vue';
import { projectService } from '@/services';
import { Export } from '@/models';

@Component({
  components: {
    ProjectEditComponent,
    ProjectAttachmentsComponet,
    ProjectLogComponet,
    ProjectRequestsComponet
  }
})
export default class ProjectDetailPage extends Vue {
  project = this.$store.state.project;
  tab = '1';
  dialog = false;
  exportColumns = Export.projectColumns;
  allColumns = true;

  created(): void {
    this.$store.dispatch('lookup/getAvailableLookup', 1);
    this.$store.dispatch('lookup/getAvailableLookup', 2);
    this.$store.dispatch('lookup/getAvailableLookup', 3);
    this.$store.dispatch('lookup/getAvailableLookup', 4);
    this.$store.dispatch('lookup/getAvailableLookup', 5);
    this.$store.dispatch('lookup/getAvailableLookup', 6);
    this.$store.dispatch('lookup/getAvailableLookup', 7);
    this.$store.dispatch('lookup/getAvailableLookup', 8);
    this.$store.dispatch('lookup/getAvailableLookup', 9);
    this.$store.dispatch('lookup/getAvailableLookup', 10);
    this.$store.dispatch('lookup/getAvailableLookup', 11);
    this.$store.dispatch('lookup/getAvailableLookup', 12);
    this.$store.dispatch('lookup/getAvailableLookup', 13);
    this.$store.dispatch('project/getById', this.$route.params.id);
    this.$store.dispatch('project/getProjectAvailableStates', this.$route.params.id);
    this.$store.dispatch('account/getOtherSolvers', '');
  }

  exportToExcel() {
    const columnsToExport = this.allColumns ? null : this.exportColumns.filter(column => column.selected);
    projectService.exportById(this.$route.params.id, columnsToExport);
    this.dialog = false;
  }

  selectAllColumns() {
    if (this.allColumns) {
      this.exportColumns.forEach(column => {
        column.selected = true;
      });
    }
  }

  columnSelected() {
    this.allColumns = this.exportColumns.filter(column => !column.selected).length === 0;
  }

  clearSelected() {
    this.exportColumns.forEach(column => {
      column.selected = false;
    });

    this.allColumns = false;
  }

  get isExportDisabled() {
    return this.exportColumns.filter(column => column.selected).length === 0;
  }
}
